import { Card, Skeleton } from "antd";
import { useEffect } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import {
    columnChartConfigurationOptions,
    pieChartConfigurationOption,
} from "../../config";
import HTTP from "../../services/httpService";
import "./style.css";

function ChartComponent() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const {
        status: genderChartStatus,
        data: genderChartRes,
        refetch: getGenderChart,
    } = useQuery(
        "genderChart",
        async () => {
            return await HTTP("/analytics/getPlatformUsedbyGenderData", {
                staff_id,
            });
        },
        { enabled: false },
    );

    const {
        status: ageChartStatus,
        data: ageChartRes,
        refetch: getAgeChart,
    } = useQuery(
        "ageChart",
        async () => {
            return await HTTP("/analytics/getPlatformUsedbyAgeData", {
                staff_id,
            });
        },
        { enabled: false },
    );

    const {
        status: guestAgeChartStatus,
        data: guestAgeChartRes,
        refetch: getGuestAgeChart,
    } = useQuery(
        "guestAgeChart",
        async () => {
            return await HTTP("/analytics/getGuestsServedAgeData", {
                staff_id,
            });
        },
        { enabled: false },
    );

    const {
        status: reviewsAgeChartStatus,
        data: reviewsAgeChartRes,
        refetch: getReviewsAgeChart,
    } = useQuery(
        "reviewsAgeChart",
        async () => {
            return await HTTP("/analytics/getReviewsAgeData", {
                staff_id,
            });
        },
        { enabled: false },
    );

    const {
        status: roomChartStatus,
        data: roomChartRes,
        refetch: getRoomChart,
    } = useQuery(
        "roomChart",
        async () => {
            return await HTTP("/analytics/getRoomsData", {
                staff_id,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getGenderChart();
        getAgeChart();
        getGuestAgeChart();
        getReviewsAgeChart();
        getRoomChart();
    }, []);

    return (
        <>
            <Card className="box-shadow margin-10">
                <h1 className="horizontal-line">Who Used Our Platform?</h1>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    {ageChartStatus !== "loading" &&
                    ageChartStatus !== "idle" ? (
                        <Chart
                            chartType="PieChart"
                            data={ageChartRes.data}
                            options={{
                                ...pieChartConfigurationOption,
                                chartArea: {
                                    width: "90%",
                                },
                                slices: {
                                    1: { color: "red" },
                                    2: { color: "yellow" },
                                    3: { color: "green" },
                                    4: { color: "blue" },
                                    5: { color: "grey" },
                                },
                                title: "Age Group",
                            }}
                        />
                    ) : (
                        <Skeleton title={false} paragraph={{ rows: 10 }} />
                    )}
                    {genderChartStatus !== "loading" &&
                    genderChartStatus !== "idle" ? (
                        <Chart
                            chartType="PieChart"
                            data={genderChartRes.data}
                            options={{
                                ...pieChartConfigurationOption,
                                chartArea: {
                                    width: "100%",
                                },
                                title: "Gender",
                            }}
                        />
                    ) : (
                        <Skeleton title={false} paragraph={{ rows: 10 }} />
                    )}
                </div>
            </Card>
            <Card className="box-shadow margin-10">
                <h1 className="horizontal-line">Customer Matrix</h1>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {roomChartStatus !== "loading" &&
                    roomChartStatus !== "idle" ? (
                        <>
                            <Chart
                                chartType="PieChart"
                                data={roomChartRes.data.chartData}
                                options={{
                                    ...pieChartConfigurationOption,
                                }}
                            />
                            <div>
                                <h1>{`${roomChartRes?.data?.hotels_total} Hotels`}</h1>
                                <h1>{`${roomChartRes?.data?.rooms_total} Rooms`}</h1>
                            </div>
                        </>
                    ) : (
                        <Skeleton title={false} paragraph={{ rows: 10 }} />
                    )}
                </div>
            </Card>
            <Card className="box-shadow margin-10">
                <h1 className="horizontal-line">Age Groups</h1>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    {guestAgeChartStatus !== "loading" &&
                    guestAgeChartStatus !== "idle" ? (
                        <Chart
                            chartType="ColumnChart"
                            data={guestAgeChartRes.data}
                            options={{
                                ...columnChartConfigurationOptions,
                                chartArea: {
                                    ...columnChartConfigurationOptions.chartArea,
                                    width: "120%",
                                },
                                legend: { position: "bottom" },
                                title: "Guests Served",
                            }}
                        />
                    ) : (
                        <Skeleton title={false} paragraph={{ rows: 10 }} />
                    )}

                    {reviewsAgeChartStatus !== "loading" &&
                    reviewsAgeChartStatus !== "idle" ? (
                        <Chart
                            chartType="ColumnChart"
                            data={reviewsAgeChartRes.data}
                            options={{
                                ...columnChartConfigurationOptions,
                                chartArea: {
                                    ...columnChartConfigurationOptions.chartArea,
                                    width: "120%",
                                },
                                legend: { position: "bottom" },
                                title: "Reviews",
                                isStacked: true,
                            }}
                        />
                    ) : (
                        <Skeleton title={false} paragraph={{ rows: 10 }} />
                    )}
                </div>
            </Card>
        </>
    );
}
export default ChartComponent;
